export const DROPDOWN_ITEM_HEIGHT = '72px'
export const DROPDOWN_ITEM_BORDER_RADIUS = '8px'
export const DROPDOWN_ITEM_ICON_SIZE = '56px'
